const $ = (selectors: string) => document.querySelector(selectors)

export default $
